<rap-add-edit-song-ui [title]="title" [errorMessage]="errorMessage$ | async" [albums]="albums" [artists]="artists"
    [isContributions]="isContributions" [producers]="producers$ | async" (addSong)="addSong($event)"
    (editSong)="editSong($event)" [songId]=""></rap-add-edit-song-ui>